import React from 'react'
import Scores from "../Scores/Scores";
import investorCharter from "../../../Assets/Files/InvestorCharter.pdf";
import investorAdvisory from "../../../Assets/Files/InvestorAdvisory.pdf";
import { Col, Container, Row } from 'react-bootstrap'
import './Style.scss'


function FooterLinks() {
  return (
    <>
      <section className="footerLinksContainer">
        <Container className='footerLinks'>
          <Row className='footerLinksRows'>
            <Col lg={3} md={6} sm={12} xs={12}>
              <div className="footerLinksHere">
                <h4 className="footerTitle">Quick Links</h4>
                <ul className="lists">
                  <li className="list"><a href="/" target="_blank" rel="noopener noreferrer">Home</a></li>
                  <li className="list"><a href="/" target="_blank" rel="noopener noreferrer">About</a></li>
                  <li className="list"><a href="contact" target="_blank" rel="noopener noreferrer">Contact</a></li>
                  <li className="list"><a href="sitemap" target="_blank" rel="noopener noreferrer">Site Map</a></li>
                  <li className="list"><a href="download" target="_blank" rel="noopener noreferrer">Downloads</a></li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={6} sm={12} xs={12}>
              <div className="footerLinksHere">
              <h4 className="footerTitle">Useful Links</h4>
                <ul className="lists">
                  <li className="list"><Scores /></li>
                  <li className="list"><a href="https://www.evotingindia.com/login_BO.jsp" target="_blank" rel="noopener noreferrer">CDSL e-Voting</a></li>
                  <li className="list"><a href="https://www.evoting.nsdl.com/eVotingWeb/commonhtmls/Login.jsp?userType=IN" target="_blank" rel="noopener noreferrer">NSDL e-Voting</a></li>
                  <li className="list"><a href="#bankDPDetails" target="_blank" rel="noopener noreferrer">Bank DP Details</a></li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={6} sm={12} xs={12}>
              <div className="footerLinksHere">
                <h4 className='footerTitle'>Investor</h4>
                <ul className="lists">
                  <li className="list"><a href={investorCharter} target="_blank" rel="noopener noreferrer">Investor Charter</a></li>
                  <li className="list"><a href="#investor-grievanve" target="_blank" rel="noopener noreferrer">Investor Grievance</a></li>
                  <li className="list"><a href="do-dont" target="_blank" rel="noopener noreferrer">Do's & Don'ts</a></li>
                  <li className="list"><a href="rules-regulations" target="_blank" rel="noopener noreferrer">Rules & Regulations</a></li>
                  <li className="list"><a href="inactive-client-policy" target="_blank" rel="noopener noreferrer">Inactive Client Policy</a></li>
                  <li className="list"><a href={investorAdvisory} target="_blank" rel="noopener noreferrer">Advisory for Investor</a></li>

                </ul>
              </div>
            </Col>
            <Col lg={3} md={6} sm={12} xs={12}>
              <div className="footerLinksHere">
              <h4 className="footerTitle">LEGAL</h4>
                <ul className="lists">
                  <li className="list"><a href="disclaimer" target="_blank" rel="noopener noreferrer">Disclaimer</a></li>
                  <li className="list"><a href="privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                  <li className="list"><a href="nse-arbitration-rules" target="_blank" rel="noopener noreferrer">NSE Arbitration Rules</a></li>
                  <li className="list"><a href="broker-norms" target="_blank" rel="noopener noreferrer">Broker Norms</a></li>
                  <li className="list"><a href="policy-procedure" target="_blank" rel="noopener noreferrer">Poliicy & Procedure</a></li>
                  {/* <li className="list"><a href="" target="_blank" rel="noopener noreferrer"></a></li> */}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default FooterLinks